import { useContext } from 'react';
import { DeckContext } from '../hoc/DeckProvider';

export function useDeck() {
	const context = useContext(DeckContext);
	if (context === null) {
		throw new Error('useDeck must be used within a DeckProvider');
	}
	return context;
}
